import {makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  rootStep: {
    margin: '40px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '50px',
    background: 'lightGrey',
    height: '65%',
  },
  detailsStep: {
    display: 'flex',
  },
  contentStep: {
    height: '1%',
    flex: '1 0 auto',
  },
  coverStep: {
    width: '75%',
  },
  iconButton: {
    padding: 8,
    margin: 0,
    marginTop: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  spacedButton: {
    margin: 8,
  },
  aceCell: {
    '&:hover': {
      background: '#ebebeb',
    },
  },
  aceListTypography: {
    marginLeft: 10,
    marginTop: 10,
  },
  rowTitleTypography: {
    fontWeight: 'bold',
    marginLeft: 10,
    marginBottom: 5,
  },
  aceListCheckbox: {
    marginLeft: 10,
    marginRight: '0px',
    height: 25,
  },
  toolbar: {
    minHeight: '56px',
  },
  toolbarDiv: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  tableRow: {
    '&:hover': {
      background: '#ebebeb',
      cursor: 'pointer',
    },
  },
}));
